"use client";

// import { navLinks } from "@/constants/route";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";

import WalletButton from "../common/WalletButton";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="fixed bg-black top-0 left-0 w-full z-50 border-b border-border-gray-primary backdrop-blur-md">
      <div className="px-4">
        <nav className="rounded-2xl px-4 md:px-5 py-3.5 flex items-center justify-between text-white max-w-7xl mx-auto mt-4 bg-black">
          {/* Logo */}
          <Link href={"/"} className="flex items-center gap-2">
            <Image
              src="/images/logo.svg"
              width={138}
              height={43}
              alt="Omega Logo"
              className="md:h-13.5 md:w-57.25 h-10 w-32.5 object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden xl:flex gap-3 items-center">
            {/* <LanguageSwitcher /> */}
            <WalletButton />
          </div>

          {/* Mobile Menu Toggle */}
          <div className="xl:hidden flex justify-center items-center">
            <button onClick={() => setMenuOpen(true)}>
              <FiMenu size={24} />
            </button>
          </div>
        </nav>
      </div>

      {/* Mobile Slider Menu */}
      <div
        ref={menuRef}
        className={`fixed top-0 right-0 h-screen w-64 bg-background-primary border-l border-border-gray-primary rounded-l-lg p-6 flex flex-col gap-6 xl:hidden z-50 transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between">
          <Link href={"/"} className="flex items-center gap-2">
            <Image
              src="/images/logo.svg"
              width={138}
              height={43}
              alt="Omega Logo"
              className="md:h-13.5 md:w-57.25 h-10 w-32.5 object-contain"
            />
          </Link>
          <button onClick={() => setMenuOpen(false)}>
            <FiX size={24} color="#fff" />
          </button>
        </div>

        <div className="flex flex-wrap gap-4 mt-auto w-full ">
          {/* <LanguageSwitcher classes=" text-center " /> */}
          <WalletButton />
        </div>
      </div>

      {/* Optional Backdrop */}
      {menuOpen && (
        <div
          onClick={() => setMenuOpen(false)}
          className="fixed inset-0  bg-opacity-40 z-40 transition-opacity duration-300 ease-in-out"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
        />
      )}
    </header>
  );
};

export default Header;
